import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCPcTLnCiZpyAX8ktg4bWgTDbIc9a05aKY",
  authDomain: "katanainu-ai.firebaseapp.com",
  databaseURL: "https://katanainu-ai-default-rtdb.firebaseio.com",
  projectId: "katanainu-ai",
  storageBucket: "katanainu-ai.appspot.com",
  messagingSenderId: "483679690434",
  appId: "1:483679690434:web:0b3e49d79353d152afe55b",
  measurementId: "G-WB6YEHBH06",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();

export { auth, db, provider, storage };
